






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardCodeBlueActivation from "./CardCodeBlueActivation.vue";
import { storeCodeBlueActivation } from "@/store/modules/CodeBlueActivationStore";

@Component({
  components: {
    CardCodeBlueActivation
  }
})
export default class CodeBlueActivationPage extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: false }) isActive!: boolean;

  get loading() {
    return storeCodeBlueActivation.loading;
  }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && !storeCodeBlueActivation.list.length) {
      this.getByRegister();
    }
  }

  mounted() {
    if (this.isActive) {
      this.getByRegister();
    }
  }

  async getByRegister() {
    await storeCodeBlueActivation.getByRegister(this.register);
  }
}
